import React from 'react'
import { useTranslation } from '../../hooks/useTranslation'

interface OrderInfoBarProps {
    className?: string
    branchName?: string
    orderType?: string
    tableNumber?: string | null
}

const OrderInfoBar: React.FC<OrderInfoBarProps> = ({
    className = '',
    branchName = 'Jeddah',
    orderType = 'Branch',
    tableNumber = null
}) => {
    const { t, currentLanguage } = useTranslation()

    const isRTL = currentLanguage === 'ar'

    // Get localized order type
    const getLocalizedOrderType = () => {
        if (orderType.toLowerCase() === 'branch' || orderType.toLowerCase() === 'pickup') {
            return t('orderInfo.pickup')
        } else if (orderType.toLowerCase() === 'delivery') {
            return t('orderInfo.delivery')
        } else if (orderType.toLowerCase() === 'dine in' || orderType.toLowerCase() === 'dinein' || orderType.toLowerCase() === 'table') {
            return t('orderInfo.dineIn')
        }
        return orderType
    }

    // Check if we should show table number
    const shouldShowTableNumber = orderType.toLowerCase() === 'table' && tableNumber

    // Get localized branch name
    const getLocalizedBranchName = () => {
        return branchName === 'Jeddah' && currentLanguage === 'ar' ? 'جدة' : branchName
    }

    return (
        <div className={`flex w-full px-3 sm:px-4 md:px-6 py-2 justify-center items-center gap-2 sm:gap-3 md:gap-4 rounded-b-xl bg-white ${isRTL ? 'flex-row-reverse' : 'flex-row'} ${className}`}
            style={{
                boxShadow: '0 2px 6px 0 rgba(18, 43, 105, 0.04), 0 1px 2px 0 rgba(18, 43, 105, 0.08), 0 0 0 1px #E1E4EA'
            }}>

            {/* Branch */}
            <div className={`flex items-center ${isRTL ? 'flex-row-reverse' : 'flex-row-reverse'}`}>
                <span className="text-xs sm:text-sm font-semibold text-gray-900">
                    {getLocalizedBranchName()}
                </span>
                <span className={`text-xs sm:text-sm font-medium text-gray-500 ${isRTL ? 'mr-1' : 'ml-1'}`}>
                    {t('orderInfo.branchName')}
                </span>
            </div>

            {/* Vertical Divider */}
            <div className="w-px h-4 bg-[#E1E4EA]"></div>

            {/* Order Type */}
            <div className={`flex items-center ${isRTL ? 'flex-row-reverse' : 'flex-row-reverse'}`}>
                <span className="text-xs sm:text-sm font-semibold text-gray-900">
                    {getLocalizedOrderType()}
                </span>
                <span className={`text-xs sm:text-sm font-medium text-gray-500 ${isRTL ? 'mr-1' : 'ml-1'}`}>
                    {t('orderInfo.orderType')}
                </span>
            </div>

            {/* Table Number - Only show for table orders */}
            {shouldShowTableNumber && (
                <>
                    {/* Vertical Divider */}
                    <div className="w-px h-4 bg-[#E1E4EA]"></div>

                    {/* Table Number */}
                    <div className={`flex items-center ${isRTL ? 'flex-row-reverse' : 'flex-row-reverse'}`}>
                        <span className="text-xs sm:text-sm font-bold text-gray-900">
                            {tableNumber}
                        </span>
                        <span className={`text-xs sm:text-sm font-medium text-gray-500 ${isRTL ? 'mr-1' : 'ml-1'}`}>
                            {t('orderInfo.tableNumber')}
                        </span>
                    </div>
                </>
            )}

        </div>
    )
}

export default OrderInfoBar